/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs */

const en_us2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of your feet wasn't on the floor. Keep both feet flat on the floor, without stepping or lifting a heel.`)
};

const pt_br2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um dos pés não estava apoiado. Deixe os dois pés inteiros no chão, sem dar passo nem erguer o calcanhar.`)
};

const es_419_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno de tus pies no estaba en el suelo. Mantén los dos pies apoyados, sin dar un paso ni levantar un talón.`)
};

const pt_pt2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um dos pés não estava apoiado. Deixa os dois pés inteiros no chão, sem dar um passo nem levantar o calcanhar.`)
};

const fr_fr2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un de tes pieds n'était pas au sol. Garde les deux pieds à plat au sol, sans faire de pas ni lever un talon.`)
};

const de_de2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einer deiner Füße war nicht auf dem Boden. Lass beide Füße flach auf dem Boden, ohne Schritt und ohne die Ferse zu heben.`)
};

const it_it2_body_assessment_pose_reason_feet_not_on_ground = /** @type {(inputs: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno dei piedi non era a terra. Tieni entrambi i piedi ben appoggiati, senza fare un passo né sollevare il tallone.`)
};

/**
* | output |
* | --- |
* | "One of your feet wasn't on the floor. Keep both feet flat on the floor, without stepping or lifting a heel." |
*
* @param {Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_feet_not_on_ground = /** @type {((inputs?: Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_Feet_Not_On_GroundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_feet_not_on_ground(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_feet_not_on_ground(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_feet_not_on_ground(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_feet_not_on_ground(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_feet_not_on_ground(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_feet_not_on_ground(inputs)
	return en_us2_body_assessment_pose_reason_feet_not_on_ground(inputs)
});
export { body_assessment_pose_reason_feet_not_on_ground as "body-assessment.pose_reason.feet_not_on_ground" }